<ng-container *ngIf="sideDrawerTemplate$ | async as sideDrawer; else page">
  <mat-drawer-container class="side-drawer-container" hasBackdrop="{{ hasBackdrop }}" (backdropClick)="closeDrawer()">
    <mat-drawer mode="over" position="end" autoFocus="false">
      <ng-template [ngTemplateOutlet]="sideDrawer.templateRef" />
    </mat-drawer>
    <ng-container [ngTemplateOutlet]="page" />
  </mat-drawer-container>
</ng-container>

<ng-template #page>
  <ng-content />
</ng-template>
